<template>
    <div v-show="popup" class="feedBackPopup-wrapper">
        <div class="popup" v-show="showForm && !showCapchaError && !showSuccessMessage">
            <div @click="closePopup" class="closer">
                <font-awesome-icon
                    class="icon close"
                    icon="times"
                ></font-awesome-icon>
            </div>
            <h3 class="popup-item popup-item-title">Обратная связь</h3>
            <div
                class="smart-capcha capcha"
                id="capcha"
            ></div>
            <ModelString
                class="popup-item"
                label="Имя"
                v-model="popupData.name"
                :valid="validation.name.valid"
            ></ModelString>
            <ModelString
                class="popup-item"
                label="Электронная почта"
                v-model="popupData.email"
                :valid="validation.email.valid"
            ></ModelString>
            <ModelTextArea
                class="popup-item popup-item-textarea"
                label="Сообщение"
                v-model="popupData.text"
                :valid="validation.text.valid"
                :maxlength="500"
            ></ModelTextArea>
            <div class="popup-actions-row">
                <div
                    :class="{'popup__button--disabled' : disabledButton }"
                    class="popup__button" v-if="!isMobile" @click="sendMessage"
                >
                    Связаться с нами
                </div>
                <div
                    :class="{'popup__button--disabled' : disabledButton }"
                    class="popup__button" v-if="isMobile" @click="sendMessage"
                >
                    Отправить
                </div>
            </div>
        </div>
        <div
            v-show="showCapchaError && !showSuccessMessage"
            class="popup"
        >
            <div @click="closePopup" class="closer">
                <font-awesome-icon
                    class="icon close"
                    icon="times"
                ></font-awesome-icon>
            </div>
            <div class="popup__capcha-error-wrapper">
                <div class="popup__capcha-error-text">
                    Ошибка!
                </div>
                <div class="popup__capcha-error-description">
                    Сервис временно недоступен! <br>
                    Попробуйте повторить попытку позже
                </div>
                <div class="popup__capcha-error-buttons">
                    <div
                        class="popup__button" @click="resend"
                    >
                        Отправить повторно
                    </div>
                    <div class="popup__button popup__button--cancel" @click="closePopup">Отменить</div>
                </div>
            </div>

        </div>
        <div v-show="showSuccessMessage" class="success">
            <h3 class="popup-item">Ваше сообщение отправлено</h3>
            <div class="success__text">
                <p>Ответ будет отправлен на указанную вами почту</p>
                <p v-if="newYearWarning">
                    <strong>Обращаем внимание,</strong> что запросы, направленные в службу технической поддержки
                    <strong>в период новогодних праздников с 31.12.2022 г. по 08.01.2023 г. включительно, будут обрабатываться с 09.01.2023.</strong>
                </p>

                <p v-if="newYearWarning">
                    <strong>Благодарим за понимание!</strong>
                </p>
            </div>
            <div class="feedBack-btn" @click="closePopup">Понятно</div>
        </div>
    </div>
</template>

<script>
import ModelString from '../UI/models/ModelString';
import ModelTextArea from '../UI/models/ModelTextArea';
import { validation } from '../../tools/comparer';
import { post, get } from '../../tools/http';
import { mapActions, mapGetters } from 'vuex';

const usersActions = ['loadUserInfo'];

const getters = ['isMobile'];
const userGetters = ['userId'];

export default {
    name: 'FeedBackPopup',

    model: {
        prop: 'popup',
        event: 'close',
    },

    props: {
        popup: Boolean,
        defaultEmail: String,
        defaultName: String,
    },

    components: {
        ModelTextArea,
        ModelString,
    },

    data: () => ({
        success: false,
        currentEmail: '',
        currentName: '',
        popupData: {
            name: '',
            email: '',
            text: '',
        },

        validation: {
            name: {
                reg: 'empty',
                type: 'hard',
                valid: true,
            },
            email: {
                reg: new RegExp(
                    '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
                    'g'
                ),
                type: 'hard',
                valid: true,
            },
            text: {
                reg: 'empty',
                type: 'hard',
                valid: true,
            },
        },
        disabledButton: true,
        smartToken: null,
        showForm: true,
        showCapchaError: false,
        showSuccessMessage: false,
    }),
    watch: {
        'popupData.email'(val) {
            this.currentEmail = '';
        },
        'popupData.name'(val) {
            this.currentName = '';
        },
        defaultName(val) {
            this.currentName = val;
        },
        defaultEmail(val) {
            this.currentEmail = val;
        },
    },
    async mounted() {
        await this.initCapcha();
    },
    computed: {
        ...mapGetters(getters),
        ...mapGetters('auth', userGetters),
        newYearWarning() {
            return Date.now() < Date.parse('2023-01-09');
        },
    },
    updated() {
        this.popupData.email && !this.currentEmail ?  '' : this.popupData.email = this.currentEmail;
        this.popupData.name && !this.currentName ?  '' : this.popupData.name = this.currentName;
    },
    methods: {
        ...mapActions('user', usersActions),
        async initCapcha() {
            const caphaKey = await get('notify', 'api/v1/captchaconfig');
            

            if (window.smartCaptcha) {
                const container = document.getElementById('capcha');
                const callback = (token) => {
                    if (token) {
                        this.disabledButton = false;
                        this.smartToken = token;
                    }
                };
                const widgetId = window.smartCaptcha.render(container, {
                    sitekey: caphaKey.site_key,
                    hl: 'ru',
                    callback: callback,
                });
            }
        },
        closePopup() {
            this.currentEmail = this.defaultEmail;
            this.currentName = this.defaultName;
            this.popupData.text = '';
            this.$emit('close', false);
            this.success = false;
            this.showForm = true;
            this.showSuccessMessage = false;
            this.showCapchaError = false;
        },
        async sendMessage() {
            let badField = validation(this.popupData, this.validation);
            if (badField.length > 0) {
                badField.forEach(key => {
                    this.validation[key].valid = false;
                    setTimeout(() => {
                        this.validation[key].valid = true;
                    }, 1000);
                });
            } else {
                const supportResult = await post(
                    'notify',
                    'api/v1/support',
                    {
                        ...this.popupData,
                        'user_id': this.userId,
                        'device_local_time': (new Date()).toLocaleString(),
                        'device_screen_width': screen.width,
                        'device_screen_height': screen.height,
                        'device_window_inner_width': window.innerWidth,
                        'device_window_inner_height': window.innerHeight,
                        'smart-token': this.smartToken,
                    }
                );

                if(!supportResult) {
                    this.currentEmail = this.defaultEmail;
                    this.currentName = this.defaultName;
                    this.showForm = false;
                    this.showCapchaError = true;
                    this.showSuccessMessage = false;
                } 
                else {
                    this.showForm = false;
                    this.showSuccessMessage = true;
                    this.disabledButton = true;
                    window.smartCaptcha.reset();
                }

            }
        },
        async resend() {
            await this.initCapcha();
            this.showForm = true;
            this.showCapchaError = false;
            this.disabledButton = true;
            this.showSuccessMessage = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';
@import '~@/styles/variables';

.capcha{
    margin-bottom: mrem(40);

    @include on-desktop {
        margin-bottom: rem(40);
    }
}

.feedBackPopup-wrapper {
    position: fixed;
    width: 100vw;
    height: 100%;
    z-index: 100000;
    background: rgba(1, 1, 1, 0.7);
    top: 0;
    left: 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;

    @include on-desktop {
        margin-bottom: rem(40);
    }
    .popup {
        width: rem(588);
        height: auto;
        max-height: 100%;
        background: #ffffff;
        border-radius: rem(4);
        padding: rem(40);
        position: relative;
        overflow-y: auto;

        &__capcha-error-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        &__capcha-error-buttons {
            width: 100%;
            @include on-desktop {
                width: auto;
            }
        }

        &__capcha-error-text {
            color: #ff0000;
            font-weight: bold;
            margin-bottom: mrem(24);
            font-size: mrem(16);
            @include on-desktop {
                margin-bottom: rem(24);
                font-size: rem(16);
            }
        }

        &__capcha-error-description {
            text-align: center;
            margin-bottom: mrem(24);
            font-size: mrem(16);
            @include on-desktop {
                margin-bottom: rem(24);
                font-size: rem(16);
            }
        }

        .popup-item {
            margin-bottom: rem(40);
            width: 100%;
        }

        .popup-item:last-child {
            margin-bottom: 0;
        }
        h3 {
            font-style: normal;
            font-weight: 600;
            font-size: rem(24);
            margin: 0;
            text-align: center;
        }
        &-actions-row {
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            width: 100%;
        }
        &__button {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            color: white;
            width: 100%;
            padding: mrem(14);
            background: #4663AB;
            border-radius: mrem(4);
            font-style: normal;
            font-weight: 600;
            font-size: mrem(16);
            cursor: pointer;

            @include on-desktop {
                padding: 0;
                cursor: pointer;
                width: rem(320);
                height: rem(48);
                font-size: rem(16);
                border-radius: rem(4);
            }

            &--disabled {
                opacity: .5;
                pointer-events: none;
            }

            &--cancel {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                background: transparent;
                color: #4663AB;
                font-size: mrem(16);

                @include on-desktop {
                    cursor: pointer;
                    width: rem(320);
                    height: rem(48);
                    font-size: rem(16);
                }
            }

        }

        .closer {
            position: absolute;
            top: rem(16);
            right: rem(24);
            z-index: 1001;
            padding: rem(8);
            cursor: pointer;
        }
    }

    .success {
        width: rem(630);
        height: auto;
        background: #ffffff;
        border-radius: rem(16);
        padding: rem(48);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;

        h3 {
            font-style: normal;
            font-weight: 600;
            font-size: rem(28);
            margin: 0;
            text-align: center;
        }
        &__text {
            text-align: center;
            font-style: normal;
            font-weight: normal;
            font-size: rem(18);
            line-height: rem(26);
            margin-top: 1rem;
            strong {
                font-weight: 600 !important;
            }
        }

        .feedBack-btn {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            color: white;
            width: rem(320);
            height: rem(48);
            background: #4663AB;
            border-radius: rem(4);
            font-style: normal;
            font-weight: 600;
            font-size: rem(16);
            margin-top: 1rem;

            cursor: pointer;
        }
    }
}

@media (max-width: $vm) {
    .feedBackPopup-wrapper {
        .popup {
            width: 90%;
            padding: mrem(40) mrem(16);
            border-radius: mrem(4);

            .popup-item-title {
                font-size: mrem(21);
                line-height: mrem(26);
                margin-bottom: mrem(32);
            }

            .popup-item {
                margin: 0 0 mrem(32) 0;
            }

            .closer {
                top: mrem(12);
                right: mrem(12);
                padding: mrem(8);
            }

            .svg-inline--fa {
                width: mrem(17);
                height: mrem(17);

                path {
                    fill: #98a0a9;
                }
            }

            .data-model.popup-item.popup-item-textarea {
                height: mrem(114);
                padding: mrem(10);
            }

            .data-model.popup-item {
                margin-bottom: mrem(40);
                border-radius: mrem(4);
                border: mrem(1) solid #d2d5d9;
                font-size: mrem(16);
                padding: mrem(13);
                height: mrem(48);
            }

            .feedBack-btn {
                width: 100%;
                height: mrem(46);
                margin: mrem(8) 0 0 0;
                font-size: mrem(16);
                line-height: mrem(20);
                border-radius: mrem(4);
            }
        }

        .success {
            width: 90%;
            padding: mrem(20) mrem(16);
            border-radius: mrem(4);

            .popup-item {
                font-size: mrem(21);
                line-height: mrem(26);
                margin-bottom: mrem(12);
            }

            &__text {
                width: 80%;
                font-size: mrem(16);
                line-height: mrem(20);
                margin-bottom: mrem(25);
            }

            .feedBack-btn {
                width: 80%;
                height: mrem(46);
                margin: mrem(8) 0 0 0;
                font-size: mrem(16);
                line-height: mrem(20);
                border-radius: mrem(4);
            }
        }
    }
}
</style>
